import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=0b77fce0&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"
import style0 from "./Users.vue?vue&type=style&index=0&id=0b77fce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77fce0",
  null
  
)

export default component.exports